export default "__VITE_ASSET__Bks24cN___"